import { Overline, AddToCartButton } from "@/components/common/ui";
import { FaqBlock } from "@/components/home/FaqBlock";

export default function Faq() {
  return (
    <div data-testid="faq-page" className="bg-[#FFFCFA]">
      <header className="border-b border-[#F2E8E6] bg-white py-20 text-center md:py-28">
        <Overline>Help Centre</Overline>
        <h1 className="mt-4 font-display text-5xl font-light text-[#2C2B2C] sm:text-7xl">Frequently asked</h1>
        <p className="mx-auto mt-5 max-w-xl px-6 text-base font-light text-[#8A7F86]">
          Everything you need to know about your Aura Glow LED Light Therapy Mask.
        </p>
      </header>
      <FaqBlock heading={false} />
      <div className="pb-24 text-center">
        <p className="mb-6 text-[#8A7F86]">Still have questions?</p>
        <AddToCartButton sku="single" label="Shop the Mask" testid="faq-add" />
      </div>
    </div>
  );
}
